import NewMedicalDocument from "../utils/medicalDocument/new";
import { useHealthCenterRules } from "../../utils/hooks";
import { homologarOrderModule } from "../homologar/orderModule";
import { orderModule } from "./module";

export const useOrderModule = () => {
  const homologarRules = useHealthCenterRules("orders.homologar");
  return homologarRules?.enabled === true ? homologarOrderModule : orderModule;
};

const NewOrder = () => <NewMedicalDocument modules={[useOrderModule()]} />;

export default NewOrder;
